// extracted by mini-css-extract-plugin
export default {"imageContainer":"ReviewScan_imageContainer__vdlto"};